function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Divider, Modal, message, Card, Drawer, Table, notification } from "antd";
import AddRoom from '../components/forms/AddRoom';
import AddBed from '../components/forms/AddBed';
import Common from '../components/includes/Common';
import { TrashFill, PencilFill, DoorOpenFill, PlusSquareFill } from 'react-bootstrap-icons';
import RoomView from '../components/RoomView';
import EditBed from './forms/EditBed';
import EditRoom from './forms/EditRoom';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;

var Rooms = function Rooms() {
  var _Modal$useModal = Modal.useModal(),
      _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
      confirm = _Modal$useModal2[0].confirm,
      contextHolder = _Modal$useModal2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isRoomVisible = _useState2[0],
      setIsRoomVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isNewRoomVisible = _useState4[0],
      setIsNewRoomVisible = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataChanged = _useState6[0],
      setIsDataChanged = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      currentRoom = _useState8[0],
      setCurrentRoom = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      rooms = _useState10[0],
      setRooms = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      roomsData = _useState12[0],
      setRoomsData = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isDataLoading = _useState14[0],
      setIsDataLoading = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showEditRoom = _useState16[0],
      setShowEditRoom = _useState16[1];

  var handleDelete = function handleDelete(r) {
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression de la salle ", r.label]
      }),
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deleteroom/" + r.id + "/" + Common.currentUser.id).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };

  var cols = [{
    title: "Nom salle",
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: "Nbre de lit",
    dataIndex: "b_count",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "b_count"
  }, {
    title: "Commandes",
    dataIndex: "room",
    render: function render(r) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsxs(Button, {
          type: "link",
          icon: /*#__PURE__*/_jsx(DoorOpenFill, {}),
          onClick: function onClick() {
            setCurrentRoom(r);
            setIsRoomVisible(true);
          },
          children: [" ", /*#__PURE__*/_jsx("b", {
            children: "ENTRER"
          })]
        }), contextHolder, /*#__PURE__*/_jsx(Button, {
          type: "default",
          icon: /*#__PURE__*/_jsx(TrashFill, {
            size: 16
          }),
          onClick: function onClick() {
            handleDelete(r);
          }
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          icon: /*#__PURE__*/_jsx(PencilFill, {
            size: 16
          }),
          onClick: function onClick() {
            setCurrentRoom(r);
            setShowEditRoom(true);
          }
        })]
      });
    },
    key: "room"
  }];
  useEffect(function () {
    setIsDataChanged(false);
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getrooms/' + Common.currentUser.id.toString()).then(function (response) {
      if (response.data.status == 200) {
        setRooms([]);
        setRoomsData([]);
        setRooms(response.data.rooms);
        response.data.rooms.forEach(function (r) {
          setRoomsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: r.label,
              room: r,
              b_count: r.beds.length
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      minHeight: "650px"
    },
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 9,
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Table, {
              bordered: true,
              columns: cols,
              dataSource: roomsData,
              loading: isDataLoading == true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              padding: "17px",
              borderRadius: "7px",
              background: "#F3F2EE"
            },
            children: [/*#__PURE__*/_jsx("h6", {
              children: /*#__PURE__*/_jsx("b", {
                children: "AJOUTER UNE SALLE"
              })
            }), /*#__PURE__*/_jsx(AddRoom, {
              handler: function handler() {
                setIsNewRoomVisible(false);
                message.success({
                  content: 'Opération réussie',
                  delay: 4
                });
                setIsDataChanged(true);
              }
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: currentRoom != null && currentRoom.label
      }),
      destroyOnClose: true,
      width: "99%",
      headerStyle: {
        background: '#2D3E4E',
        borderRadius: '0px',
        color: '#EEE'
      },
      open: isRoomVisible,
      onClose: function onClose() {
        setIsRoomVisible(false);
      },
      children: currentRoom != null && /*#__PURE__*/_jsx(RoomView, {
        room: currentRoom
      })
    }), currentRoom && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["Modifier la salle - ", currentRoom.label]
        }),
        destroyOnClose: true,
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        footer: null,
        open: showEditRoom,
        onCancel: function onCancel() {
          setShowEditRoom(false);
        },
        children: /*#__PURE__*/_jsx(EditRoom, {
          room: currentRoom,
          handler: function handler() {
            setIsDataChanged(true);
          }
        })
      })
    })]
  });
};

export default Rooms;